function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it) return (it = it.call(o)).next.bind(it);

  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it) o = it;
    var i = 0;
    return function () {
      if (i >= o.length) return {
        done: true
      };
      return {
        done: false,
        value: o[i++]
      };
    };
  }

  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;

var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};

var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) {
    if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  }

  if (__getOwnPropSymbols) {
    for (var _iterator = _createForOfIteratorHelperLoose(__getOwnPropSymbols(b)), _step; !(_step = _iterator()).done;) {
      var prop = _step.value;
      if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
    }
  }

  return a;
};

var __markAsModule = function __markAsModule(target) {
  return __defProp(target, "__esModule", {
    value: true
  });
};

var __export = function __export(target, all) {
  __markAsModule(target);

  for (var name in all) {
    __defProp(target, name, {
      get: all[name],
      enumerable: true
    });
  }
};

__export(exports, {
  default: function _default() {
    return src_default;
  },
  focusStyle: function focusStyle() {
    return _focusStyle;
  },
  hexToRgb: function hexToRgb() {
    return _hexToRgb;
  },
  mediaQuery: function mediaQuery() {
    return _mediaQuery;
  },
  themeColors: function themeColors() {
    return _themeColors;
  },
  themeTokens: function themeTokens() {
    return _themeTokens;
  },
  typeStyle: function typeStyle() {
    return _typeStyle;
  }
});

var _themeColors = {
  blue: {
    1: "#cfeaf2",
    2: "#00b3d9",
    3: "#018dc0",
    4: "#00619e",
    5: "#045489",
    6: "#183558",
    7: "#122946"
  },
  yellow: {
    1: "#fbf2de",
    2: "#feb948",
    3: "#eb9f23"
  },
  green: {
    1: "#ebfbee",
    2: "#2f9e44",
    3: "#237032"
  },
  red: {
    1: "#fff5f5",
    2: "#e03131",
    3: "#b02525"
  },
  white: "#ffffff",
  black: "#000000",
  grey: {
    1: "#f4f8fa",
    2: "#d9dde9",
    3: "#aab1c7",
    5: "#6d7184"
  },
  special: {
    "marketplace-purple": "#9b51e0"
  }
};
var _themeTokens = {
  color: __spreadValues({}, _themeColors),
  elevation: {
    "0": "none",
    "1": "0px 2px 3px rgba(24, 53, 88, 0.1)",
    "2": "0px 6px 13px rgba(24, 53, 88, 0.1)"
  },
  breakpoint: {
    xs: "0px",
    s: "414px",
    m: "768px",
    l: "1024px",
    xl: "1280px",
    xxl: "1440px"
  },
  font: {
    family: "'Brandon Text', -apple-system, BlinkMacSystemFont, 'Segoe UI',\n    Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji',\n    'Segoe UI Emoji', 'Segoe UI Symbol'"
  },
  type: {
    brand: {
      all: {
        fontFamily: "Brandon Text",
        textTransform: "uppercase",
        fontWeight: 700
      },
      xl: {
        fontSize: "72px",
        lineHeight: "72px"
      },
      l: {
        fontSize: "54px",
        lineHeight: "54px"
      },
      m: {
        fontSize: "40px",
        lineHeight: "40px"
      },
      s: {
        fontSize: "28px",
        lineHeight: "28px"
      }
    },
    header: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 700
      },
      xxl: {
        fontSize: "40px",
        lineHeight: "44px"
      },
      xl: {
        fontSize: "28px",
        lineHeight: "32px"
      },
      m: {
        fontSize: "20px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "16px",
        lineHeight: "20px"
      },
      xs: {
        fontSize: "14px",
        lineHeight: "20px"
      }
    },
    label: {
      all: {
        fontFamily: "Brandon Text",
        textTransform: "uppercase",
        fontWeight: 700
      },
      l: {
        fontSize: "18px",
        lineHeight: "28px"
      },
      m: {
        fontSize: "14px",
        lineHeight: "16px"
      },
      s: {
        fontSize: "12px",
        lineHeight: "16px"
      },
      xs: {
        fontSize: "10px",
        lineHeight: "12px"
      }
    },
    body: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 400
      },
      l: {
        fontSize: "18px",
        lineHeight: "28px"
      },
      m: {
        fontSize: "16px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "14px",
        lineHeight: "20px"
      },
      xs: {
        fontSize: "12px",
        lineHeight: "16px"
      }
    },
    link: {
      all: {
        fontFamily: "Brandon Text",
        fontWeight: 400,
        textDecoration: "underline"
      },
      m: {
        fontSize: "16px",
        lineHeight: "24px"
      },
      s: {
        fontSize: "14px",
        lineHeight: "20px"
      }
    }
  },
  border: {
    radius: "3px"
  },
  form: {
    focus: {
      light: {
        boxShadow: "0 0 0 1px white, 0 0 0 3px " + _themeColors.blue["3"]
      },
      dark: {
        boxShadow: "0 0 0 1px " + _themeColors.blue["3"] + ", 0 0 0 3px white"
      }
    }
  }
};

var _typeStyle = function _typeStyle(name, theme) {
  if (name === void 0) {
    name = "-";
  }

  if (theme === void 0) {
    theme = _themeTokens;
  }

  var _ref = name == null ? void 0 : name.split("-"),
      textName = _ref[0],
      textSize = _ref[1];

  var _theme = theme,
      type = _theme.type;
  var textType = type[textName == null ? void 0 : textName.toLowerCase()] || {};
  return __spreadValues(__spreadValues({}, textType.all), textType[textSize]);
};

var _focusStyle = function _focusStyle(name, theme) {
  if (name === void 0) {
    name = "light";
  }

  if (theme === void 0) {
    theme = _themeTokens;
  }

  var _theme2 = theme,
      form = _theme2.form;
  var focusStyles = (form == null ? void 0 : form.focus) || {};
  var styleObj = focusStyles[name.toLowerCase()] || {};
  return styleObj;
};

var _mediaQuery = function _mediaQuery(name, theme) {
  if (name === void 0) {
    name = "md";
  }

  if (theme === void 0) {
    theme = _themeTokens;
  }

  var alias = {
    "small-mobile": "xs",
    "tablet-portrait": "s",
    "tablet-landscape": "m",
    laptop: "l",
    desktop: "xl",
    "large-desktop": "xxl"
  };
  var useName = alias[name] || name;
  var _theme3 = theme,
      breakpoint = _theme3.breakpoint;
  var bp = breakpoint[useName] || "";
  return "@media (min-width: " + bp + ")";
};

var _hexToRgb = function _hexToRgb(input) {
  var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  var hex = input.replace(shorthandRegex, function (m, r, g, b) {
    return r + r + g + g + b + b;
  });
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result ? {
    r: parseInt(result[1], 16),
    g: parseInt(result[2], 16),
    b: parseInt(result[3], 16)
  } : {};
};

var src_default = _themeTokens;